import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useState, useCallback, useEffect } from 'react';
import { useUserAccounts } from './UserAccountsContext';
import { useAuth } from './AuthenticationContext';
import { ReportsApi } from '../api/ReportsApi';
const ProfitTrendsContext = createContext(undefined);
export const useProfitTrends = () => {
    const context = useContext(ProfitTrendsContext);
    if (!context) {
        throw new Error('useProfitTrends must be used within ProfitTrendsProvider');
    }
    return context;
};
export const ProfitTrendsProvider = ({ children }) => {
    const [profitTrends, setProfitTrends] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(undefined);
    const { selectedAccountId } = useUserAccounts();
    const { authenticated } = useAuth();
    const refresh = useCallback(async () => {
        if (!selectedAccountId)
            return;
        setLoading(true);
        setError(undefined);
        try {
            const data = await ReportsApi.getProfitTrends(selectedAccountId);
            setProfitTrends(data);
        }
        catch (err) {
            console.error('ProfitTrends error:', err);
            setError(err.message || 'Failed to load profit trends');
        }
        finally {
            setLoading(false);
        }
    }, [selectedAccountId]);
    useEffect(() => {
        if (!authenticated)
            return;
        if (selectedAccountId) {
            refresh();
        }
    }, [authenticated, selectedAccountId, refresh]);
    return (_jsx(ProfitTrendsContext.Provider, { value: { profitTrends, loading, error, refresh }, children: children }));
};
